"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slotData.type.target': '目标',
    'slotData.type.goal': '目标',
};
